import { PreguntasTipoEnum } from "../enums/PreguntasTipo.enum";
import { Nilable } from "./Nullable";

export class PreguntasUtils {
    public static obtenerTipo(tipo: string): Nilable<PreguntasTipoEnum> {
        switch (tipo.toLowerCase()) {
        case "single":
        case "simple":
        case "s":
            return PreguntasTipoEnum.SINGLE_CHOICE;

        case "múltiple":
        case "multiple":
        case "m":
            return PreguntasTipoEnum.MULTIPLE_CHOICE;

        case "rango":
        case "range":
        case "r":
            return PreguntasTipoEnum.NUMERIC_IN_RANGE;

            // Video

        case "texto libre":
        case "texto":
        case "text":
        case "t":
            return PreguntasTipoEnum.TEXT;

        case "texto numerico":
        case "texto numérico":
        case "numerico":
        case "numeric_text":
        case "numeric text":
        case "n":
            return PreguntasTipoEnum.NUMERIC_TEXT;

        case "url":
        case "u":
            return PreguntasTipoEnum.URL;

        case "toma foto":
        case "foto":
        case "photo":
        case "picture":
        case "f":
            return PreguntasTipoEnum.PICTURE;

            // Sorted

        case "informativa":
        case "info":
        case "i":
            return PreguntasTipoEnum.INFO;

        case "matriz (single choice)":
        case "matrix":
        case "matriz simple":
        case "matriz single":
        case "sm":
            return PreguntasTipoEnum.MATRIX_SINGLE;

        case "matriz (multiple choice)":
        case "multimatrix":
        case "matriz multiple":
        case "mm":
            return PreguntasTipoEnum.MATRIX_MULTIPLE;

        case "matriz (rango)":
        case "matriz rango":
        case "rm":
            return PreguntasTipoEnum.MATRIX_RANGE;

        case "puntos extra":
        case "puntos":
        case "pts":
            return PreguntasTipoEnum.EXTRA_POINTS;

        case "distributiva":
        case "distrib":
        case "distributiv":
        case "distribution":
        case "distribución":
            return PreguntasTipoEnum.DISTRIBUTION;

        case "date":
        case "fecha":
            return PreguntasTipoEnum.DATE_SELECT;

        case "rank":
        case "ranking":
            return PreguntasTipoEnum.RANKING;

        case "checkpoint":
        case "check":
        case "chk":
            return PreguntasTipoEnum.FLOW_CHECKPOINT;

        case "grupo":
        case "g":
        case "bloque":
            return PreguntasTipoEnum.FLOW_GROUP;

        case "salto":
        case "j":
        case "jump":
        case "salto condicionado":
            return PreguntasTipoEnum.FLOW_JUMP;

        case "random":
        case "rnd":
        case "derivador random":
            return PreguntasTipoEnum.FLOW_RANDOM;

        case "item match":
        case "match":
            return PreguntasTipoEnum.ITEM_MATCH;
        case "video":
            return PreguntasTipoEnum.VIDEO;

        case "resultado":
            return PreguntasTipoEnum.RESULTADO;
        case "desplegable":
            return PreguntasTipoEnum.DESPLEGABLE;
        case "slider text":
            return PreguntasTipoEnum.SLIDER_TEXT;
        case "si/no":
        case "sino":
        case "si no":
            return PreguntasTipoEnum.SIYNO;
        case "grafical choice":
            return PreguntasTipoEnum.GRAPHICAL_CHOICE;
        default:
            return null;
        }
    }
}
